const url = process.env.NODE_ENV === "development" ? "" : "https://dnhq.draft-vote.xyz";
export default url;
